import type { ReactNode, Ref } from "react";
import { Glyph } from "./Glyph";
import { Keycap } from "./SectionLabel";
import { cn } from "@/lib/utils";
import { FOCUS_RING } from "./focusRing.constants";
const PLACEMENT_CLASS = {
  md: "h-9 w-full gap-2.5 bg-ink/[0.05] pl-4 pr-2 text-ink-2 hover:bg-ink/[0.08]",
  island: "h-8 w-[min(220px,28vw)] flex-shrink-0 gap-2 bg-ink/[0.08] pl-3 pr-1.5 text-ink-3 hover:bg-ink/[0.12]"
};
export function SearchTrigger({
  placeholder,
  label,
  shortcut,
  ariaKeyShortcuts,
  ariaExpanded,
  ariaControls,
  leading,
  placement = "md",
  onClick,
  className,
  ref
}: {
  placeholder: string;
  label: string;
  shortcut?: string;
  ariaKeyShortcuts?: string;
  ariaExpanded?: boolean;
  ariaControls?: string;
  leading?: ReactNode;
  placement?: keyof typeof PLACEMENT_CLASS;
  onClick: () => void;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
}) {
  return <button ref={ref} type="button" onClick={onClick} aria-label={label} aria-keyshortcuts={ariaKeyShortcuts} aria-expanded={ariaExpanded} aria-controls={ariaControls} className={cn("flex items-center rounded-full text-callout transition-colors", FOCUS_RING, PLACEMENT_CLASS[placement], className)} data-sentry-component="SearchTrigger" data-sentry-source-file="SearchTrigger.tsx">
            {leading ?? <Glyph name="search" className="h-4 w-4 shrink-0" />}
            <span className="min-w-0 flex-1 truncate text-left">
                {placeholder}
            </span>
            {shortcut && <Keycap>{shortcut}</Keycap>}
        </button>;
}